<template>
  <div class="page-training">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
        <el-breadcrumb-item>创业联盟</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content" v-loading="loading">
        <column-header2 :data="metaData"></column-header2>
        <training-card v-for="item in leagueList" :data="item" :key="item.id"></training-card>
        <el-pagination v-if="total > pageSize" class="g-pagination" background layout="prev, pager, next" :current-page="pageIndex" :page-size="pageSize" :total="total" @current-change="handleIndexChange">
          ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import ColumnHeader from "_c/ColumnHeader2";
import Card from "./Card";
import SideNav from "_c/SideNav";
import { getData } from "api/app";
import { mapState } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      metaData: {
        name: "联盟成员"
      },
      leagueList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1
    };
  },
  computed: {
    ...mapState('college', ['collegeData'])
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [Card.name]: Card,
    [SideNav.name]: SideNav
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      let params = [{ Key: 'College', Value: this.collegeData.cid, CompareType: 'EqualTo' }]
      var queryParams = {
        name: "League",
        index: this.pageIndex,
        size: this.pageSize ?? 10,
        params: params
      };
      getData(queryParams)
        .then(res => {
          this.leagueList = res.Data || [];
          this.total = res.TotalCount;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        })
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-training {
  background: #f6f6f9;
  padding-bottom: 40px;
  .g-content {
    padding: 0 72px 40px 72px;
  }
  ::v-deep .comp-training {
    margin-bottom: 24px;
  }
}
</style>
